/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RolesAndAccessEntrypointProps } from './RolesAndAccess.entrypoint.types.tsx';

type RolesAndAccessEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	{},
	RolesAndAccessEntrypointProps,
	{}
>;

export const rolesAndAccessEntryPoint: EntryPoint<RolesAndAccessEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<RolesAndAccessEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-roles-and-access" */ './RolesAndAccess.tsx',
		),
		getPreloadProps: () => ({}),
	});
